<template>
    <div>

        <!-- yellow div -->
        <div class="bg-yellow" >
            <div class="container relative tc tl-m">
                <div class="w-70-ns center w-100-m flex pt5">

                    <!-- descriptive text -->
                    <div class="w-60-m w-50-l">
                        <img class="mt4-m" src="@/assets/img/landing/section1_tooliaba_logo.svg">
                        <h1 class="mt3">Ever wish you had the right tool for your project?</h1>
                        <h3 class="mt4" style="font-weight:800;">Get the tools and equipment you need, when you need it.</h3>
                    </div>
                    
                    <!-- images (medium or larger) -->
                    <div v-if="screenSize === 'md' || screenSize === 'lg'" class="w-40-m w-50-l flex justify-between" style="height: 420px;" >
                        <div></div>
                        <img class="absolute right-0 right-2-l z-1" src="@/assets/img/landing/section1_larry_the_dog.svg">
                        <img class="w-100" src="@/assets/img/landing/section1_starburst_desktop.svg">
                    </div>

                </div>
            </div>
            
            <!-- starburst image (small or smaller) -->
            <div v-if="screenSize === 'xs' || screenSize === 'sm'" class="tc">
                <img  style="height:470px;" src="@/assets/img/landing/section1_starburst_mobile.svg">
            </div>
              
            <img class="w-100 db" src="@/assets/img/landing/divider_rough_edge_top.svg">
        </div>
        
        <div class="bg-black white pb5 relative">

            <!-- Larry (small or smaller) -->
            <img v-if="screenSize === 'xs' || screenSize === 'sm'" class="absolute" style="top: -450px; margin-left:auto; margin-right:auto; left:0; right:0;" src="@/assets/img/landing/section1_larry_the_dog.svg">

            <div class="container tc tl-m" :style="[screenSize === 'xs' || screenSize === 'sm' ? {'padding-top': '260px'} : {'padding-top': '85px'}]">
                <div class="col-xs-12">
                    <h2 class="w-70-ns left-m w-60-m" :class="{'center' : screenSize === 'sm'}">
                        Connect with nearby tool owners to get that 'one tool' you need to get the job done.
                    </h2>
                
                
                    <div class="row mt5 mt6-l">
                        <LandingBenefit
                            :image="require(`@/assets/img/landing/section2_icon_money.svg`)"
                            title="You save money."
                            description="Stop paying a lot of money for a tool you'll only use once."
                        />
                        <LandingBenefit
                            class="mt5 mt0-ns"
                            :image="require(`@/assets/img/landing/section2_icon_time.svg`)"
                            title="You save time."
                            description="Request a tool and POOF! - it's delivered and ready to use."
                        />
                        <LandingBenefit
                            class="mt5 mt0-ns"
                            :image="require(`@/assets/img/landing/section2_icon_space.svg`)"
                            title="You save space."
                            description="Don't waste precious storage space with unused tools."
                        />
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
    
<script>
import LandingBenefit from '@/components/landing/LandingBenefit.vue';

export default {
    components: {
        LandingBenefit
    },
    computed: {
        screenSize() {
            return this.$mq;
        }
    }
};
</script>
